// extracted by mini-css-extract-plugin
module.exports = {"container":"uE3NUM","image":"_3qSc1W","loader":"IrpbqA","upchargePrice":"_3KFiVI","labels":"_1rL6ZR"};